import { createSortOption } from "@nosto/preact"
export const sizes = [24, 48, 72]

export const sortOptions = [
    createSortOption("score", "Most relevant", { field: "_score", order: "desc" }),
    createSortOption("-price", "Price descending", { field: "price", order: "desc" }),
    createSortOption("price", "Price ascending", { field: "price", order: "asc" })
]

export const sizesOrder = [
    "2",
    "4",
    "6",
    "8",
    "10",
    "12",
    "14",
    "16",
    "18",
    "20",
    "22",
    "24",
     
    "XS",
    "S",
    "M",
    "L",
    "XL",

    "1-2 YRS",
"3-4 YRS",
"5-6 YRS",

"36",
"37",
"38",
"39",
"40",
"41",

"4-24",
"1-6 YEARS",
"4-24 PRINTED",
"4/24 PDF",
"1-6 YEARS PRINTED",
"1-6 YEARS PDF",
"ONE SIZE PRINTED",
"ONE SIZE PDF",

]

export const excludeSizes = [
    "mobile",
    "desktop",
"mini",
"5 labels",
"20mm",
"12mm",
"2021",
"x-small/small",
"xx-large",
"medium/large",
"s/m",
"xs/s",
"m/l",
"l/xl",
"SMALL",
"X-SMALL",
"MEDIUM",
"LARGE",
"X-LARGE",
"XX-LARGE",
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[0],
    autocompleteProductsSize: 4,
    autocompleteKeywordsSize: document.body.clientWidth > 991 ? 5 : 4,
    historySize: 5
}


export const colorMap = {
    pink: '#FDA3C0',
    orange: '#FF9557',
    green: '#7CC55B',
    purple: '#9D1F7D',
    grey: '#9D9292',
    brown: '#8D5252',
    red: '#DA372A',
    yellow: '#FCFF9E',
    blue: '#45B3CD',
    white: '#FFFFFF',
    black: '#000000',
    beige: '#D9C79C',
    gingham: 'rubynz.com/cdn/shop/files/black-ladder-gingham.png?v=1689030035&width=50',
    floral: 'rubynz.com/cdn/shop/files/melon-floral.png?v=1706822262&width=50'
};
